import Request from '../../data/request'
import ApiIntegrationRequest from "../../api-request/api-intergration";

export default class ApiIntegrationGoogleDrive {

    static listFiles(folder:string) {
        return ApiIntegrationRequest.GET(this,'gdrive/ls/'+gd.companyId+'/'+folder);
    }

    static disable() {
        return new Request(this, 'DELETE' ,`company/${gd.companyId}/integrations/g-drive`);
    }

    static get connectUrl() {
        // @ts-ignore
        const googleDriveConnectUrl = gdConfig.apiIntegration + "gdrive/connect/" + gd.companyId;

        return googleDriveConnectUrl
    }

    static moduleStatus() {
        return new Request(this,'GET','company/'+gd.companyId+'/integrations/g-drive');
    }



}
